
import dayjs from 'dayjs';


export const calculateCheckInDateTime = (checkOutDate, checkOutTime, rentalDurationHours = 4) => {
  if (!checkOutDate || !checkOutTime) {
    return { checkInDate: null, checkInTime: null };
  }

  // Ensure rentalDurationHours is a valid number, default to 4 if not
  const duration = parseInt(rentalDurationHours, 10) || 4;

  const checkOutDateTime = dayjs(`${checkOutDate.format('YYYY-MM-DD')}T${checkOutTime.format('HH:mm')}`);
  const checkOutHour = checkOutDateTime.hour();
  const checkOutDay = checkOutDateTime.day(); // 0=Sunday, ..., 5=Friday, 6=Saturday

  // Use the provided rental duration (default: 4 hours after checkout)
  let checkInDateTime = checkOutDateTime.add(duration, 'hour');

  // Special cases
  if (checkOutHour >= 14) {
    if (checkOutDay === 5) {
      // Friday checkout → Monday 8 AM
      return {
        checkInDate: checkOutDateTime.add(3, 'day').startOf('day'),
        checkInTime: dayjs('12:00', 'HH:mm')
      };
    }
    // Weekday checkout → next day 8 AM
    return {
      checkInDate: checkOutDateTime.add(1, 'day').startOf('day'),
      checkInTime: dayjs('12:00', 'HH:mm')
    };
  }

  // Normal: 4 hours later
  return {
    checkInDate: checkInDateTime,
    checkInTime: checkInDateTime
  };
};

export const shouldDisableDate = (date) => {
  const day = date.day();
  const today = dayjs().startOf('day');
  
  // Disable weekends: 0 = Sunday, 6 = Saturday
  if (day === 0 || day === 6) {
    return true;
  }
  
  // Disable past dates
  if (date.isBefore(today, 'day')) {
    return true;
  }
  
  return false;
};
